/**
 * Saves a blob to the user's machine.
 * Creates an object URL, triggers the download via a temporary anchor, then cleans up.
 * @param blob The file contents
 * @param filename The filename for the downloaded file (e.g., "export.zip")
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
